export const enum TicketType {
  SupportTicket,
  StartupTicket,
}

/**
 * These values should match the tags in the "Support Plan" Zendesk ticket field:
 * https://mixpanelsupport.zendesk.com/agent/admin/ticket_fields/360021981892
 */
export const enum SupportPlan {
  McdonaldsCustom = `mcdonalds_custom`,
  Custom = `custom`,
  Gold = `gold`,
  Platinum = `platinum`,
  Premium = `premium`,
  Silver = `silver`,
  Standard = `standard`,
  Unmapped = `unmapped`,
}

/**
 * values to match tags in zendesk:
 * https://mixpanelsupport1553889792.zendesk.com/admin/objects-rules/tickets/ticket-fields/34196036658196
 */
export const enum Severity {
  SEV_0 = `sev0`,
  SEV_1 = `sev1`,
  SEV_2 = `sev2`,
}
export const SeverityLabels = {
  [Severity.SEV_0]: `Severity 0`,
  [Severity.SEV_1]: `Severity 1`,
  [Severity.SEV_2]: `Severity 2`,
};

/**
 * These values should match the tags in the "Tier" Zendesk ticket field:
 * https://mixpanelsupport.zendesk.com/agent/admin/ticket_fields/360021982312
 */
export const enum SupportPlanTier {
  Strategic = `strategic`,
  Tier1 = `tier_1`,
  Tier2 = `tier_2`,
  Enterprise = `enterprise`,
  Growth = `growth`,
  Free = `free_tier`,
}

/**
 * These values should match the tags in the "Request Type" Zendesk ticket field:
 * https://mixpanelsupport.zendesk.com/agent/admin/ticket_fields/360021982112
 */
export const enum RequestType {
  HelpUsingMixpanel = `help_using_mixpanel`,
  HelpWithMyAccount = `help_with_my_account`,
  ReportAnIssue = `report_an_issue`,
}

export const enum RequestSubtype {
  // Product area
  DashboardHelp = `dashboard_help`,
  AnalysisHelp = `analysis_help`,
  UsersHelp = `users_help`,
  DataManagementHelp = `data_management_help`,
  IntegrationsHelp = `integrations_help`,
  PipelinesHelp = `pipelines_help`,
  ImplementationHelp = `implementation_help`,

  // Account area
  BillingPaymentsAndPricing = `billing__payments__and_pricing`,
  AccountManagement = `account_management`,
  PersonalDataAndGdpr = `personal_data_and_gdpr`,

  // Issue
  Bug = `customer_report_bug`,
  ReportsNotLoading = `reports_not_loading`,
  MessagesNotSending = `messages_not_sending`,
  DataIngestionIssues = `data_ingestion_issues`,

  // All three areas
  OtherHelp = `other_help`,
}

export interface ZendeskUpload {
  token: string;
}

export interface ZendeskTicketData {
  id: number;
  serviceArr: number;
  supportPlan: SupportPlan;
  supportPlanTier: SupportPlanTier;
  totalArr: number;
  comment: string;
  eventsPlanId: number;
  peoplePlanId: number;
  featureGateName: string;
  features: string[];
  requestSubtype: RequestSubtype;
  requestType: RequestType;
  subject: string;
  uploads: ZendeskUpload[];
  userAgeInDays: number;
  userEmail: string;
  userId: string;
  userName: string;
  severity: string;
}
